export enum CarouselType {
  BasicCarousel = 'BasicCarousel',
  TopCarousel = 'TopCarousel',
  RecommendedCarousel = 'RecommendedCarousel',
  CollectionCarousel = 'CollectionCarousel',
  ContinueWatchingCarousel = 'ContinueWatchingCarousel',
  MyListCarousel = 'MyListCarousel',
  MickMack = 'MickMack',
  GenericCarousel = 'GenericCarousel',
  SeasonCollectionCarousel = 'SeasonCollectionCarousel',
  SeasonBasicCarousel = 'SeasonBasicCarousel',
  RecommendationCarousel = 'RecommendationCarousel',
}

export enum CarouselLayout {
  LandscapeSmall = 'LandscapeSmall',
  LandscapeLarge = 'LandscapeLarge',
  PortraitSmall = 'PortraitSmall',
  PortraitLarge = 'PortraitLarge',
  PortraitTop10 = 'PortraitTop10',
}

export enum GenericCarouselLayout {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}
